<template>
  <v-app style="background-color:white">

    <v-card class="form-container">
      <v-layout row wrap>
          <v-flex xs12>
              <p>Order Id :&nbsp;{{form.orderCode}}</p>
              <p>Order Date :&nbsp;{{form.date}}</p>
              <p>{{form.remark}}</p>
              <p style="text-align:right">{{form.commentOn}}</p>
          </v-flex>

          <v-flex xs12 style="text-align:right">
              <v-btn depressed color="#e53935" dark @click="back()">Cancel</v-btn>
          </v-flex>
      </v-layout>
    </v-card>
  </v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      title: "Create Counselling",
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,
      edit: false,

      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
      },
      valid: true,
      roleType: sessionStorage.roles,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "UOM",
          disabled: false,
          to: "/uom"
        },
        {
          text: "Create",
          disabled: true,
          to: "/createStudent"
        }
      ],
      form: {
          UomName: null
      }
    };
  },

  mounted() {
      this.axios
      .get(config.API + `OrderRemarks/${this.$route.params.id}`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.form = res.data;
        console.log(this.form);
      });
    },

  methods: {
    back() {
      this.$router.go(-1);
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .put(
            config.API + `Uoms/${this.$route.params.id}`,
            {
              id: JSON.parse(this.$route.params.id),  
              uomName: this.form.UomName
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully updated");
            //this.$router.push(`counsellingImage/${code}`);
            this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  }
};
</script>

<style>
.bckgrnd {
  background-color: #424242;
  background-size:cover !important;
}
</style>
